import { Waves, Wifi, Snowflake, Car, Sun, Flame, Trees, Eye, Utensils, WashingMachine, Tv, Dumbbell, Bath, Baby, Dog, Bike, Coffee, Check,
  Thermometer, Monitor, Disc, Music, Radio, Phone, Sofa, BookOpen, Dices, UtensilsCrossed, Microwave, CookingPot, Refrigerator, Egg, Armchair,
  BedDouble, BedSingle, ShowerHead, Wind, Shirt, Lock, Accessibility, CigaretteOff, CalendarClock, Volume1, Umbrella, Building2,
  Mountain, Droplets, Flower2, Tent, Fence, Sparkles, Ban, Sprout, Landmark, Blinds, Warehouse, ChevronDown } from "lucide-react";

const MAP = [
  [/^wlan|wifi|internet/i, Wifi], [/^pc$|computer/i, Monitor], [/^tv|fernseh|smart/i, Tv], [/dvd/i, Disc], [/musik/i, Music], [/radio/i, Radio], [/telefon/i, Phone],
  [/schlafsofa/i, Sofa], [/schreibtisch/i, Monitor], [/bücher|buecher/i, BookOpen], [/spiele/i, Dices], [/esstisch/i, UtensilsCrossed],
  [/heizung/i, Thermometer], [/klima|aire|air ?con/i, Snowflake], [/kamin|chimenea|fireplace/i, Flame],
  [/mikrowelle/i, Microwave], [/geschirrsp/i, Sparkles], [/kaffee|coffee|frühstück|desayuno|breakfast/i, Coffee], [/toaster/i, Utensils], [/saftpresse|mixer/i, Utensils],
  [/kühlschrank|kuehlschrank|gefrier/i, Refrigerator], [/backofen|herd/i, CookingPot], [/eierkocher/i, Egg], [/wasserkocher/i, Coffee], [/hochstuhl/i, Armchair], [/brötchen/i, Sprout],
  [/kinderbett|baby|kind|niñ|child/i, Baby], [/stockbett/i, BedSingle], [/einzelbett/i, BedSingle], [/doppelbett|bett/i, BedDouble],
  [/dusche/i, ShowerHead], [/badewanne|whirlpool|jacuzzi|sauna/i, Bath], [/bidet/i, Droplets], [/handtüch|bademant|bettwäsche/i, Shirt], [/föhn|foen/i, Wind],
  [/pool|piscina/i, Waves], [/wasch|lavadora|washer|laundry/i, WashingMachine], [/trockner/i, Wind], [/bügel/i, Shirt], [/safe/i, Lock], [/grill|bbq|barbacoa/i, Flame],
  [/spielplatz/i, Baby], [/meerblick|wasserblick|vista|sea view|ocean/i, Eye], [/bergblick/i, Mountain], [/poolblick|gartenblick/i, Eye],
  [/dachterrasse/i, Building2], [/terrasse|terraza|terrace|balkon|balcon/i, Sun], [/wintergarten/i, Flower2], [/garten|jard|garden|liegewiese/i, Trees], [/gartenmöbel/i, Armchair],
  [/sportger|fitness|gym/i, Dumbbell], [/strandkorb/i, Tent], [/sonnenliegen/i, Sun], [/sonnenschirm|markise/i, Umbrella], [/aufzug/i, Building2], [/park|garage|aparc/i, Car],
  [/rollstuhl|barrierefrei/i, Accessibility], [/haustier|hund|pet|mascota/i, Dog], [/nichtraucher/i, CigaretteOff],
  [/langzeit/i, CalendarClock], [/ruhige/i, Volume1], [/strandurlaub/i, Umbrella], [/golf/i, Landmark], [/mietwagen/i, Car], [/fahrrad|bike|bici/i, Bike], [/küche|kueche|cocina|kitchen/i, Utensils],
];
import { trAmenity, trGroup } from "@/lib/amenityI18n";
import { useAmenityCatalog, groupAmenities } from "@/lib/amenityCatalog";
import { useState } from "react";
import { useLang } from "@/context/LanguageContext";
export const amenityIcon = (name) => (MAP.find(([re]) => re.test(name)) || [null, Check])[1];

const Item = ({ a, compact }) => {
  const { lang } = useLang();
  const Icon = amenityIcon(a);
  const label = trAmenity(a, lang);
  return compact ? (
    <span title={label} className="w-8 h-8 rounded-full bg-soft text-brand flex items-center justify-center" data-testid="amenity-icon"><Icon className="w-4 h-4" /></span>
  ) : (
    <div className="flex items-center gap-3 rounded-xl border border-line bg-white px-3 py-2.5 text-sm text-stone-700" data-testid="amenity-item">
      <span className="w-9 h-9 rounded-full bg-soft text-brand flex items-center justify-center shrink-0"><Icon className="w-4 h-4" /></span>{label}
    </div>
  );
};

const Group = ({ g, items, lang }) => (
  <div>
    <div className="text-xs uppercase tracking-widest text-stone-500 mb-2" data-testid={`amenity-group-${g}`}>{trGroup(g, lang)} <span className="text-stone-400">({items.length})</span></div>
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">{items.map((a) => <Item key={a} a={a} />)}</div>
  </div>
);

export const AmenityList = ({ amenities, grouped, compact = false, flat = false, limit = 0, keepOrder = false }) => {
  const { lang, t } = useLang();
  const cat = useAmenityCatalog();
  const [showAll, setShowAll] = useState(false);
  const base = (a) => a.replace(/\s*\([^)]*cm\)\s*$/i, "");
  const list = amenities || [];
  const rank = (a) => { const m = cat?.items.find((x) => x.label.de === base(a)); return m ? (m.default ? -1 : m.sort) : 9999; };
  const n = Number(limit) || 0;
  const all = keepOrder ? [...list] : [...list].sort((a, b) => rank(a) - rank(b));  // keepOrder = eigene Reihenfolge (z. B. je Anlage)
  const truncated = n > 0 && all.length > n && !showAll;
  const sorted = truncated ? all.slice(0, n) : all;
  // Mehr-/Weniger-Schalter (wie auf der Objektseite), wenn die Einstellung die Liste kürzt
  const toggle = n > 0 && all.length > n && (
    <button type="button" onClick={() => setShowAll((v) => !v)} className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-brand-deep hover:underline" data-testid="amenity-list-toggle" aria-expanded={showAll}>
      <ChevronDown className={`w-4 h-4 transition-transform ${showAll ? "rotate-180" : ""}`} />
      {showAll ? t.property.showLessAmenities : t.property.showAllAmenities.replace("{n}", all.length)}
    </button>
  );
  const groups = cat ? groupAmenities(sorted) : grouped;
  if (!compact && !flat && groups && Object.keys(groups).length) {
    const order = cat ? cat.groupKeys : Object.keys(groups);
    const keys = [...order.filter((k) => groups[k]), ...Object.keys(groups).filter((k) => !order.includes(k))];
    return (
      <div className="space-y-6" data-testid="amenity-list">
        {keys.map((g) => <Group key={g} g={g} items={groups[g]} lang={lang} />)}
        {toggle}
      </div>
    );
  }
  return (
    <div data-testid="amenity-list">
      <div className={compact ? "flex flex-wrap gap-2" : "grid grid-cols-2 sm:grid-cols-3 gap-3"}>
        {sorted.map((a) => <Item key={a} a={a} compact={compact} />)}
      </div>
      {toggle}
    </div>
  );
};
